export const reduxKey = '@@CONTACT_US';
